import type { ReactNode } from 'react'
import '../src/index.css'

// Root Layout is deliberately a passthrough. Page-level layouts in
// pages/product/+Layout.tsx and pages/product-variant/+Layout.tsx wrap
// their children in the shop chrome (header/footer/cart context/etc.),
// while the SPA shell at pages/index renders its own chrome via App.tsx
// so it must not be wrapped a second time.
export default function Layout({ children }: { children: ReactNode }) {
  return <>{children}</>
}
